import {Component, OnInit, inject} from '@angular/core';
import {DataService} from "../../services/data.service";
import {NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrl: './settings.component.scss',
    imports: [NgIf, FormsModule]
})
export class SettingsComponent implements OnInit {

    private dataService = inject(DataService);

    user: any;

    ngOnInit(): void {
        this.dataService.request('User/get').subscribe(response => {
            this.user = response.user;
        });
    }

}
